import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootState } from '../app/store';

interface Environment {
  backendUrl: string;
}

interface EnvironmentState {
  env: Environment | null;
  status: 'idle' | 'pending' | 'succeeded' | 'failed'
}

const initialState: EnvironmentState = {
  env: null,
  status: 'idle'
};

export const fetchEnv = createAsyncThunk(
  'env/fetchEnv',
  async () => {
    const response = await axios.get('environment.json');
    return response.data as Environment;
  }
);

export const environmentSlice = createSlice({
  name: 'environment',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEnv.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchEnv.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.env = payload;
      })
      .addCase(fetchEnv.rejected, (state) => {
        state.status = 'failed';
        state.env = null;
      });
  },
});
export const selectEnvironment = (state: RootState): EnvironmentState => state.environment;
export default environmentSlice.reducer;